import React, { useEffect, useState, useRef } from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCAcknowledgement.scss';
import { Card, CardImg } from 'reactstrap';
import PreviewImageAndClick from '../../../widgets/PreviewImageAndClick/PreviewImageAndClick';

const YDCAcknowledgement = (props) => {
  const { curLang, acknowledgementList, title, acknowledgement_detail } = props;

  const [previewImgOpen, setPreviewImgOpen] = useState(false);
  const [selectImgIndex, setSelectImgIndex] = useState(0);
  const previewImgToggle = () => setPreviewImgOpen(!previewImgOpen);
  const selectImgIndexFun = (index) => setSelectImgIndex(index);

  const imageList = acknowledgementList.map((item, index) => ({
    image: item.acknowledgement_images_upload,
  }));

  return (
    <>
      <PageTitle title={title} />
      <div className="ydc-acknowledgement">
        <div className="acknowledgement-card-grid">
          {imageList.map((item, index) => {
            // if (index === 8 || index === 11) {
            //   return <Card key={index} className="acknowledgement-card blank"></Card>;
            // }
            return item.image ? (
              <Card
                key={index}
                className="acknowledgement-card"
                onClick={() => {
                  selectImgIndexFun(index);
                  setPreviewImgOpen(true);
                }}
              >
                <div className="card-container">
                  <CardImg src={item.image} alt={`ack-image-${index}`} />
                  {(acknowledgement_detail?.[index]?.acknowledgement_title ||
                    acknowledgement_detail?.[index]?.acknowledgement_name) && (
                    <div className="itemCaption">
                      <div className="title">
                        {acknowledgement_detail[index].acknowledgement_title}
                      </div>
                      {acknowledgement_detail?.[index]?.acknowledgement_name && (
                        <div className="description">
                          {acknowledgement_detail[index].acknowledgement_name}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Card>
            ) : null;
          })}
        </div>
      </div>
      <PreviewImageAndClick
        previewImgToggle={previewImgToggle}
        previewImgOpen={previewImgOpen}
        selectImgIndex={selectImgIndex}
        selectImgIndexFun={selectImgIndexFun}
        imageList={imageList}
      />
    </>
  );
};

export default YDCAcknowledgement;
